import moment from "moment";
import {defaultFormProduct} from "./state";

export function setReservationProducts(state, reservationProducts) {
    const data = Array.isArray(reservationProducts) ? reservationProducts : [];

    state.reservationProducts = data.map(item => {
        let userReleaseFullName = "";
        let userReleaseFullNameWithDate = "";

        if (item.user_release) {
            userReleaseFullName =
                item.user_release && item.user_release.contact
                    ? item.user_release.contact.full_name_with_identification
                    : `${item.user_release.name} ${item.user_release.username}`;
            userReleaseFullNameWithDate = `${userReleaseFullName} ${moment(
                item.release_date
            ).format("YYYY-MM-DD HH:mm")}`;
        }

        const userCreateOrEditFullName =
            item.user_create_or_update && item.user_create_or_update.contact
                ? item.user_create_or_update.contact
                      .full_name_with_identification
                : `${item.user_create_or_update.name} ${item.user_create_or_update.username}`;
        const userCreateOrEditFullNameWithDate = `${userCreateOrEditFullName} ${moment(
            item.create_or_update_date
        ).format("YYYY-MM-DD HH:mm")}`;

        return {
            ...item,
            shipmentDateFormatted: moment(item.shipment_date).format(
                "YYYY-MM-DD"
            ),
            dueDateFormatted: moment(item.due_date).format("YYYY-MM-DD"),
            contactFullName: item.contact.full_name_with_identification,
            productFullName: `${item.product.code} - ${item.product.description}`,
            userCreateOrEditFullName: userCreateOrEditFullNameWithDate,
            userReleaseFullName: userReleaseFullNameWithDate
        };
    });
}

export function setReservationProduct(state, reservationProduct) {
    state.reservationProduct = reservationProduct;

    if (reservationProduct) {
        state.form.id = reservationProduct.id;
        state.form.contact_id = reservationProduct.contact_id;
        state.form.shipment_date = reservationProduct.shipment_date;
        state.form.due_date = reservationProduct.due_date;
        state.form.product_id = reservationProduct.product_id;
        state.form.lot = reservationProduct.lot;
        state.form.observation = reservationProduct.observation;
        state.form.quantity = reservationProduct.quantity;
    }
}

export function setLoading(state, loading) {
    state.loading = loading;
}

export function setError(state, error) {
    state.error = error;
}

export function setContacts(state, data) {
    state.contacts = data;
}

export function setProducts(state, data) {
    state.products = data;
}

export function resetDefaultFormProduct (state) {
    Object.assign(state.form, defaultFormProduct());
    state.reservationProduct = null;
}



// WEBPACK FOOTER //
// ./src/modules/reservationProduct/mutations.js